import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, Panel } from '../../ui';

/**
 * Paste-a-link panel of the toolbar: Enter adds a link card or an embed at the centre of the view. A `Panel` (P16-2):
 * its close button, Escape and a press outside close it.
 */
export function LinkInput({ onCreate, onClose }: { onCreate: (url: string) => boolean; onClose: () => void }) {
  const { t } = useTranslation();
  const [value, setValue] = useState('');
  const [invalid, setInvalid] = useState(false);
  const field = useRef<HTMLInputElement>(null);
  return (
    <Panel title={t('links.url')} closeLabel={t('common.close')} onClose={onClose} placement="bottom" initialFocus={field} finalFocus={false}>
      <form
        className="flex gap-1"
        onSubmit={(e) => {
          e.preventDefault();
          if (onCreate(value)) onClose();
          else setInvalid(true);
        }}
      >
        <Input
          ref={field}
          type="url"
          value={value}
          aria-label={t('links.url')}
          aria-invalid={invalid}
          placeholder="https://"
          onChange={(e) => {
            setValue(e.target.value);
            setInvalid(false);
          }}
        />
        <Button type="submit" variant="primary">
          {t('links.create')}
        </Button>
      </form>
    </Panel>
  );
}
